import {
  TextContent,
  TextList,
  TextListVariants,
  TextListItem,
  TextListItemVariants,
} from '@patternfly/react-core'
import * as React from 'react'
import styled from 'styled-components'
import { ArrowBackOutline } from 'styled-icons/evaicons-outline'

import type { IPatient } from '@app/domain/patient/patient.interface'

import { HeaderContainer, ScreenContent } from './content-layout'
import { ContinueButton, ControlRow, Control, BackButton } from './controls'

const FormQuestions = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: start;
  padding-bottom: 1rem;
`

const ScreenHeader = styled.div`
  text-align: center;
  color: ${(props) => props.theme.colors.primary};
  font-size: 16pt;
  font-weight: 500;
`

interface IntakeFormProps {
  patient?: IPatient
  handleContinue?: () => void
  handleGoBack?: () => void
  handleSubmit?: (
    instrumentId: string,
    responses: Record<string, string>,
  ) => void
}

export class IntakeDemographics extends React.Component<IntakeFormProps> {
  renderHeader = (header?: string) => {
    if (!header) {
      return null
    }

    return (
      <HeaderContainer>
        <ScreenHeader dangerouslySetInnerHTML={{ __html: header }} />
      </HeaderContainer>
    )
  }

  renderContinueButton = () => {
    return this.props.handleSubmit ? (
      <ContinueButton onClick={() => this.props.handleContinue()}>
        Continue
      </ContinueButton>
    ) : (
      <></>
    )
  }

  getQuestions = () => [
    {
      id: 'familyName',
      inputType: 'text',
      label: 'Family Name',
      required: true,
    },
    {
      id: 'givenNames',
      inputType: 'text',
      label: 'Given Name',
      required: true,
    },
    {
      id: 'dateOfBirth',
      inputType: 'date',
      label: 'Date of Birth',
      required: true,
    },
    {
      id: 'birthSex',
      inputType: 'binary',
      label: 'Birth Sex',
      required: true,
      options: {
        Male: 'male',
        Female: 'female',
        Other: 'other',
        Unknown: 'unknown',
      },
    },
  ]

  renderBackButton = (goBack?: () => void) => {
    if (goBack) {
      return (
        <BackButton onClick={goBack}>
          <ArrowBackOutline size="45" />
        </BackButton>
      )
    } else {
      return null
    }
  }

  render() {
    const header =
      'Please review this information.<br/>If it is not accurate, please inform the front desk.'
    const { handleGoBack, patient } = this.props
    return (
      <ScreenContent>
        {this.renderHeader(header)}
        <FormQuestions>
          {patient ? (
            <TextContent>
              <TextList component={TextListVariants.dl}>
                <TextListItem component={TextListItemVariants.dt}>
                  Family Name:
                </TextListItem>
                <TextListItem component={TextListItemVariants.dd}>
                  {patient.familyName}
                </TextListItem>
                <TextListItem component={TextListItemVariants.dt}>
                  Given Name(s):
                </TextListItem>
                <TextListItem component={TextListItemVariants.dd}>
                  {patient.givenNames}
                </TextListItem>
                <TextListItem component={TextListItemVariants.dt}>
                  Date of Birth:
                </TextListItem>
                <TextListItem component={TextListItemVariants.dd}>
                  {patient.dateOfBirth}
                </TextListItem>
                <TextListItem component={TextListItemVariants.dt}>
                  Birth Sex:
                </TextListItem>
                <TextListItem component={TextListItemVariants.dd}>
                  {patient.birthSex}
                </TextListItem>
              </TextList>
            </TextContent>
          ) : (
            <></>
          )}
        </FormQuestions>
        <ControlRow>
          <Control>
            <Control>{this.renderBackButton(handleGoBack)}</Control>
          </Control>
          <Control>{this.renderContinueButton()}</Control>
          <Control />
        </ControlRow>
      </ScreenContent>
    )
  }
}
